'use strict';
/**
 * [init initilizes tabs]
 * @param  {[string]} scope [css selector]
 * @return {[undefined]}    [nothing returned]
 */
export function init(scope){

    $('.page-header-top').on('click', '.btn-search', function(){
        $('.page-header .search-box').slideToggle();
        $('.page-header .search-box').find('input').focus();
        return false;
    });

    $('.search-box').on('click', '.btn-close', function(){
        $('.page-header .search-box').slideToggle();
        return false;
    });

}
